import theme from 'styles/themes/default';
import type { CSSProperties } from 'react';

type Props = {
  className?: string;
  'data-test'?: string;
  gradientStop1?: string;
  gradientStop2?: string;
  height?: string | number;
  styles?: CSSProperties;
  width?: string | number;
};

function WWRegion({
  className,
  'data-test': dataTest,
  height = 88,
  gradientStop1 = theme.colors.gray['300'],
  gradientStop2 = theme.colors.gray['400'],
  styles = {},
  width = 89,
}: Props) {
  return (
    <svg
      className={className}
      data-test={dataTest}
      fill="none"
      height={height}
      style={styles}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M88.4946 43.9504C88.4651 19.7107 68.7416 0 44.4987 0C20.2369 0 0.5 19.7402 0.5 44.0027C0.5 68.2625 20.2369 88 44.4987 88C68.7416 88 88.4651 68.292 88.4946 44.055C88.4946 44.0362 88.5 44.0215 88.5 44.0027C88.5 43.9839 88.4946 43.9691 88.4946 43.9504ZM44.4987 82.3818C43.7729 82.3818 43.0526 82.3576 42.3349 82.3187C39.3434 77.9173 36.9328 72.6894 35.1849 66.9223C38.057 66.6231 40.9827 66.4581 43.9513 66.4581C46.7966 66.4581 49.6029 66.599 52.357 66.8753C50.601 72.6814 48.1783 77.9427 45.1654 82.3657C44.9413 82.3697 44.7213 82.3818 44.4987 82.3818ZM26.3312 41.1936H6.23073C6.75793 33.9696 9.28792 27.2969 13.2707 21.7257C17.9109 23.6172 22.9078 25.0526 28.1502 26.0091C27.12 30.8881 26.4962 35.9926 26.3312 41.1936ZM33.7146 26.8355C37.0629 27.2178 40.4796 27.4378 43.9513 27.4378C47.2996 27.4378 50.5956 27.2419 53.8259 26.8851C54.8078 31.4623 55.4115 36.2756 55.5738 41.1936H31.9506C32.1143 36.2568 32.722 31.4288 33.7146 26.8355ZM26.3339 46.8118C26.4989 52.1228 27.1307 57.3185 28.1918 62.2632C22.991 63.209 18.0316 64.627 13.4223 66.4917C9.35098 60.8788 6.76195 54.127 6.23073 46.8118H26.3339ZM31.9493 46.8118H55.5738C55.4088 51.8424 54.793 56.7416 53.7789 61.3872C50.5621 61.0358 47.2809 60.8426 43.9513 60.8426C40.4984 60.8426 37.0951 61.0599 33.7589 61.4396C32.7367 56.7792 32.117 51.8612 31.9493 46.8118ZM57.9844 67.6574C62.7131 68.469 67.2284 69.6912 71.4299 71.3157C66.2478 76.4282 59.6237 80.0824 52.2295 81.6024C54.5838 77.4021 56.5222 72.7069 57.9844 67.6574ZM59.3487 62.1975C60.399 57.2742 61.0255 52.1027 61.1905 46.8118H82.7639C82.222 54.2786 79.5444 61.1592 75.3255 66.8405C70.3715 64.7517 65.0003 63.201 59.3487 62.1975ZM61.1905 41.1936C61.0282 36.014 60.4124 30.9311 59.3902 26.0735C65.0807 25.0593 70.4882 23.4844 75.4717 21.3702C79.6034 27.0112 82.226 33.8153 82.7639 41.1936H61.1905ZM71.6351 16.8842C67.3934 18.5423 62.8244 19.7845 58.0394 20.6122C56.5691 15.4662 54.6227 10.6636 52.2416 6.40032C59.727 7.9417 66.4262 11.6671 71.6351 16.8842ZM45.1748 5.63298C48.2212 10.1136 50.6667 15.485 52.4267 21.3983C49.6526 21.676 46.8194 21.8196 43.9513 21.8196C40.9599 21.8196 38.0113 21.6519 35.1191 21.3474C36.8724 15.4783 39.3032 10.1404 42.3268 5.68127C43.0472 5.63968 43.7702 5.61554 44.4987 5.61554C44.7267 5.61688 44.9494 5.63029 45.1748 5.63298ZM35.0802 6.7907C32.8038 10.9386 30.9324 15.5843 29.5105 20.5492C25.1507 19.7738 20.9694 18.663 17.063 17.1981C21.9245 12.2171 28.1234 8.55209 35.0802 6.7907ZM17.2549 71.0058C21.1223 69.5731 25.2567 68.4825 29.5615 67.7205C30.9767 72.5915 32.836 77.1325 35.0816 81.212C28.22 79.4747 22.0895 75.8849 17.2549 71.0058Z"
        fill="url(#paint0_linear)"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint0_linear"
          x1={0}
          x2={Number(width) * 0.6}
          y1={0}
          y2={Number(height) * 1.2}
        >
          <stop stopColor={gradientStop1} />
          <stop offset="1" stopColor={gradientStop2} />
        </linearGradient>
      </defs>
    </svg>
  );
}
export default WWRegion;
